"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLiverElastography = createLiverElastography;
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    liverElastography: {
        id: "dashboard.liver_elastography",
        defaultMessage: "Elasztográfia"
    },
    fibrosisStage: {
        id: "dashboard.fibrosis_stage",
        defaultMessage: "Fibrosis stádium"
    },
    steatosisGrade: {
        id: "dashboard.steatosis_grade",
        defaultMessage: "Steatosis grade"
    }
};
const values = [
    {
        label: messages.fibrosisStage,
        query: queries_1.queries.fibrosisStage
    },
    {
        label: messages.steatosisGrade,
        query: queries_1.queries.steatosisGrade
    }
];
function createLiverElastography(intl, { events }) {
    return (0, shared_1.createList)(intl, {
        events,
        label: messages.liverElastography,
        values,
        createItem: shared_1.createStringListItem
    });
}
